import * as React from 'react';
import { useCallback } from 'react';
import { ICompredScript } from '../../../../models/ICompredScript';

type CompareScriptLineProps = {
    scriptName: string,
    script: ICompredScript,
    goToScript: (script: ICompredScript, e: MouseEvent) => void
}

export function CompareScriptLine({ scriptName, script, goToScript }: CompareScriptLineProps) {
    const goToScriptCb = useCallback((e) => {
        goToScript(script, e);
    }, [script, goToScript]);

    return <div
        className={`compare-script-line ${scriptName === script.name && 'selected'} ${script.updated && 'updated'} ${!script.added && !script.deleted && !script.updated && 'not-updated'} ${script.added && 'added'} ${script.deleted && 'deleted'}`}
        onClick={goToScriptCb}>
        <span title={script.name}>
            {script.name}
        </span>
    </div>;
}

export default CompareScriptLine;
